import { mapActions } from 'vuex';

export default {
  name: 'ServiceBanner',

  components: {},

  props: {
    banner: {
      type: Object,
      default: (() => { })
    }
  },

  data() {
    return {

    };
  },

  computed: {
    is_external() {
      return !this.banner.is_category_link;
    },
    title() {
      return this.banner.label;
    },
    description() {
      return this.banner.description;
    },
    label() {
      return this.banner.button_label;
    },
    link() {
      return this.banner.link;
    },
  },

  methods: {
    ...mapActions(['selectCategory']),
    handleClick() {
      this.selectCategory(this.link);
    },
  },
}


// WEBPACK FOOTER //
// ./src/components/Services/ServiceBanner/component.js